<template>
  <div role="main" class="main" style="z-index: -2">
    <section class="page-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul class="breadcrumb">
              <li class="active">Dashboard Pendaftaran</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <!--modal here -->
      <div class="row">
        <div class="col-md-3">
          <sidebar />
        </div>
        <div class="col-md-9">
          <!-- loading here -->
          <!--<flash-message></flash-message>
          <center>
            <pulse-loader style="margin: 15px" :loading="$store.state.formData.loading" color="#696969" size="10px"></pulse-loader>
          </center>
          -->
          <div class="row">
            <div class="col-md-12">
              <div v-if="!$store.getters.getStatusYudisiumOk" class="alert alert-info">
                Status pendaftaran : <b>{{ $store.getters.getStatusData.status_pendaftar }}</b>
              </div>
              <div v-if="$store.getters.getStatusYudisiumOk" class="alert alert-info" style="text-align: center;">
                <div v-if="$store.getters.getStatusYudisium.yudisium_status_diterima === 'DITERIMA'">
                  <div>Selamat {{ $store.getters.getStatusYudisium.yudisium_nama_peserta }}</div>
                  <br>
                  <div>
                    <b>Anda Dinyatakan Lulus Seleksi</b> 
                    {{ $store.getters.getAuthData.data.mhs_jalur.penawaran_jalur.jalur.jalur_masuk }} 
                    Gelombang {{ $store.getters.getAuthData.data.mhs_jalur.penawaran_jalur.gelombang }}
                  </div>
                  <br>
                  <div>
                    diterima di program studi <b>{{ $store.getters.getStatusYudisium.yudisium_nama_prodi }} 
                    ({{ $store.getters.getStatusYudisium.yudisium_nama_jenjang }})</b>. 
                    Informasi terkait registrasi dapat diakses melalui website 
                    <a href="admisi.uin-suka.ac.id" target="_blank">admisi.uin-suka.ac.id</a> atau 
                    <a href="uin-suka.ac.id" target="_blank">uin-suka.ac.id</a> pada kolom pengumuman.
                  </div>
                </div>
                <div v-if="$store.getters.getStatusYudisium.yudisium_status_diterima === 'TIDAK DITERIMA'">
                  <div>Mohon Maaf {{ $store.getters.getStatusYudisium.yudisium_nama_peserta }}</div>
                  <br>
                  <div>
                    <b>Anda Dinyatakan Tidak Lulus Seleksi</b> 
                    {{ $store.getters.getAuthData.data.mhs_jalur.penawaran_jalur.jalur.jalur_masuk }} 
                    Gelombang {{ $store.getters.getAuthData.data.mhs_jalur.penawaran_jalur.gelombang }}
                  </div>
                </div>
                <div v-if="!$store.getters.getStatusYudisium.yudisium_status_diterima">
                  <div>Data Kelulusan Tidak Ditemukan</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="$store.getters.getStatusData.pengumuman">
            <div v-for="item in $store.getters.getStatusData.pengumuman" class="alert alert-info">
              <p>{{ item.title }}</p>
              <div v-html="item.announcement"></div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-12"
              :style="`${$store.getters.chatData.openChat ? '' : 'z-index: 0'}`"
            >
              <ProgressCardPendaftar />
              <!-- <div style="z-index: 9">
                <Chat />
              </div> -->
            </div>
          </div>
          <div class="row visible-xs">
            <div class="col-md-12">
              <h4 class="heading-primary"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailPengumuman(item.id_pengumuman)"
                    style="cursor: pointer"
                    >{{ item.judul }}</a
                  >
                </li>
              </ul>
              <h4 class="heading-primary"><i class="fa fa-newspaper-o"></i> Artikel</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.artikel.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailArtikel(item.id_berita)"
                    style="cursor: pointer"
                  >
                    {{ item.judul }}</a
                  >
                </li>
                <li>
                  <a @click="() => goToCardArtikel()" style="cursor: pointer">
                    <h6 class="heading-primary">
                      Selengkapnya...
                    </h6>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProgressCardPendaftar from "./information/ProgressCardPendaftar.vue";
// import Chat from "./chat/Chat";
export default {
  data() {
    return {};
  },
  components: { ProgressCardPendaftar },
  name: "DashboardPendaftar"
};
</script>



// WEBPACK FOOTER //
// src/page/DashboardPendaftar.vue